// extracted by css-extract-rspack-plugin
export default {"wrapper":"_278ee9c2","button":"_23d4f647","clickable":"_bddfd1b5","selected":"_955ebb78","arrowIcon":"_44049363","elipses":"_1c864744"};